import { render, staticRenderFns } from "./TextSimple.vue?vue&type=template&id=643954f7"
import script from "./TextSimple.vue?vue&type=script&lang=js"
export * from "./TextSimple.vue?vue&type=script&lang=js"
import style0 from "./TextSimple.vue?vue&type=style&index=0&id=643954f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports